import React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from '../hooks/useAuth';

const AuthGuard = ({ children }) => {
  const { badgedIn, isAuthenticated } = useAuth();
  console.log('Auth Guard Triggered');

  if (!isAuthenticated) {
    return <Redirect to="/login" />;
  } else if (!badgedIn) {
    return <Redirect to="/badgescan" />
  } else
  return (
    <>
      {children}
    </>
  );

};

AuthGuard.propTypes = {
  children: PropTypes.node
};

export default AuthGuard;
